import type { GasViscosityCalculator } from "../d";

export const chenRuthGasViscosityCalculator: GasViscosityCalculator =
  params => {
    const {
      temperatureKelvin,
      gasMolecularWeight,
      psuedoCriticals: { psuedoReducedPressure, psuedoReducedTemperature }
    } = params;

    // N87: =(0.0038539+0.0000356*D29)-(0.0004131+0.0000016*D29)*SQRT(D33)
    const A =
      0.0038539 +
        0.0000356 * temperatureKelvin -
        (0.0004131 + 0.0000016 * temperatureKelvin) *
          Math.sqrt(gasMolecularWeight) || 0;

    // N89: =(-0.488439+D36*-0.0943952+D36^2*0.01199591)*(1/D35)
    const B =
      (-0.488439 +
        psuedoReducedPressure * -0.0943952 +
        psuedoReducedPressure ** 2 * 0.01199591) *
        (1 / psuedoReducedTemperature) || 0;

    // N91: =(0.8269923+D36*1.71241+D36^2*(-0.0700968))*(1/(D35^4))
    const C =
      (0.8269923 +
        psuedoReducedPressure * 1.71241 +
        psuedoReducedPressure ** 2 * -0.0700968) /
        psuedoReducedTemperature ** 4 || 0;

    // N93: =(1.20700968+D36*0.0301188+D36^2*-0.0048318)
    const D =
      1.20700968 +
        psuedoReducedPressure * 0.0301188 +
        psuedoReducedPressure ** 2 * -0.0048318 || 0;

    // N95: =(N47*EXP(N49*N53^N51))/10000
    const gasViscosityCP = (B + C + D) * A || 0;

    return {
      gasViscosityCP,
      intermediates: {
        A,
        B,
        C,
        D,
        psuedoReducedTemperature,
        psuedoReducedPressure
      }
    };
  };
